import type { LiveStreamEvent } from '~/graphql/types.gen';
import { isEventEnded } from '~/singlePageApp/screens/LiveStreamScreen/Broadcast/utils/eventHelpers';

type JoinableEvent = Pick<LiveStreamEvent, 'lifecycleStatus'> & {
  settings: Pick<LiveStreamEvent['settings'], 'preRecorded' | 'rtmpIngestEnabled'>;
};

export const isJoinRequired = (event: JoinableEvent): boolean => {
  const isEnded = isEventEnded(event.lifecycleStatus);
  return !isEnded && !event.settings.rtmpIngestEnabled && !event.settings.preRecorded;
};
